import React, { useCallback, useContext, useState, useRef } from "react";
import { withRouter, Redirect } from "react-router";
import app from "../../services/base.js";
import firebase from "firebase";
import { AuthContext } from "../../services/Authentication.js";
import GoogleIcon from "../../assets/google-logo.png";
import AppleIcon from '../../assets/apple-logo.png';
import "./Login.scss";

const Login = ({ history }) => {
  const { currentUser } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [showError, setShowError] = useState(null);
  const [showLoading, setShowLoading] = useState(false);
  const [activeSubmit, setActiveSubmit] = useState(false);
  const inputPasswordRef = useRef();
  const handleLogin = useCallback(
    async (event) => {
      setShowLoading(true);
      event.preventDefault();
      setShowError(null);
      const { email, password } = event.target.elements;
      try {
        await app
          .auth()
          .signInWithEmailAndPassword(email.value, password.value);
        history.push("/");
        setShowLoading(false);
      } catch (error) {
        setShowError(error);
        console.log(error);
        setShowLoading(false);
      }
    },
    [history]
  );

  const googleLogin = useCallback(
    async (event) => {
      event.preventDefault();
      try {
        setShowLoading(true);
        var provider = new firebase.auth.GoogleAuthProvider();
        // provider.setCustomParameters({ promt: "select_account", });
        app
          .auth()
          .signInWithPopup(provider)
          .then((result) => {
            setShowLoading(false);
            history.push("/");
          })
          .catch((error) => {
            setShowLoading(false);
          });
      } catch (error) {}
    },
    [history]
  );

  const appleLogin = useCallback(
    async (event) => {
      event.preventDefault();
      try {
        setShowLoading(true);
        var provider = new firebase.auth.OAuthProvider("apple.com");
        provider.addScope("email");
        // provider.setCustomParameters({ promt: "select_account", });
        app
          .auth()
          .signInWithPopup(provider)
          .then((result) => {
            setShowLoading(false);
            history.push("/");
          })
          .catch((error) => {
            setShowLoading(false);
          });
      } catch (error) {}
    },
    [history]
  );

  // const resetPassword = useCallback(
  //   async event => {
  //     event.preventDefault();
  //     try {
  //        await app.auth().sendPasswordResetEmail()
  //     } catch (error) {
  //     }
  //   },
  //   [history]
  // );
  function onChangeEmail(event) {
    setActiveSubmit(event.target.value.length > 0);
  }
  function togglePassword() {
    setShowPassword(!showPassword);
    if (inputPasswordRef && inputPasswordRef.current) {
      inputPasswordRef.current.focus();
    }
  }

  if (currentUser) {
    return <Redirect to="/" />;
  }

  return (
    <>
      {showLoading && <div class="loader" />}
      <div className="login-page">
        <div className="container">
          <div className="header">
            <h4>Bom te ver novamente!</h4>
            <h5>Agora suas conversas podem ser acessadas na web :D</h5>
          </div>
          <div className="container-content">
            <form
              name="form1"
              className="box"
              onSubmit={handleLogin}
              method="post"
            >
              <h3>Entrar</h3>
              <div className="form__group field">
                <input
                  type="email"
                  className="form__field"
                  placeholder="Email"
                  name="email"
                  id="email"
                  required
                  enterKeyHint="next"
                  onChange={onChangeEmail}
                />
                <label for="email" className="form__label">
                  Email
                </label>
              </div>
              <div className="form__group field">
                <input
                  ref={inputPasswordRef}
                  type={showPassword ? "text" : "password"}
                  className="form__field"
                  placeholder="Senha"
                  minLength={8}
                  security={true}
                  name="password"
                  id="password-input"
                  autocomplete="off"
                  required
                />
                <label for="Senha" className="form__label">
                  Senha
                </label>
                <span
                  toggle="#password-field"
                  className="show-password"
                  onClick={togglePassword}
                >
                  {!showPassword ? "Mostrar senha" : "Esconder senha"}
                </span>
              </div>
              {/* <label>
            <input type="checkbox"/>
            <span></span>
            <small className="rmb">Remember me</small>
          </label> */}
              {/* <a onClick={} href="#" className="forgetpass">Recuperar senha</a> */}
              {showError && (
                <span className="error">Email ou senha incorretos</span>
              )}
              <button
                className="submit-button btn1"
                style={{
                  backgroundColor: activeSubmit ? "#0256ad" : "#8ab0d7",
                }}
                type="submit"
              >
                Entrar
              </button>
            </form>
            <div className="otherLogin">
              <div className="sign-in-form__or-divider">
                <span className="sign-in-form__or-span">ou</span>
              </div>
              <div className="google-sign-in-cta">
                <button type="button" onClick={googleLogin}>
                  <img
                    className="onload lazy-loaded"
                    src={GoogleIcon}
                    alt="google icon"
                  />
                  <span>Continuar com o Google</span>
                </button>
              </div>
               
              <div className="apple-sign-in-cta">
                <button type="button" onClick={appleLogin}>
                <img
                    className="onload lazy-loaded"
                    src={AppleIcon}
                    alt="apple icon"
                  />
                  <span>Continuar com o Apple</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(Login);
